/** "1, 2,3" -> [1, 2, 3]; blanks and non-numbers are dropped. */
const parseIdList = (raw: string | undefined): number[] =>
  (raw ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s !== '')
    .map(Number)
    .filter((n) => !Number.isNaN(n));

export const APP_CONFIG = {
  name: 'Attendance',
  shortName: 'Attendance',
  subtitle: 'Attendance Management',
  homeRoute: '/attendance',
  allowedEmailDomain: process.env.REACT_APP_ALLOWED_EMAIL_DOMAIN || '',
  /** Providers whose users may open the shift dashboard, e.g. "1,2,3".
   *  Empty means nobody — fail closed, so a missing env can never expose it. */
  enableDashboardProviderIds: parseIdList(
    process.env.REACT_APP_ENABLE_DASHBOARD_PROVIDER_IDS
  ),
  loginTitle: 'Login to your account',
  loginDescription: 'Enter your details to login.',
  copyright: '© 2026 Dash Electric. All rights reserved',
};

export const getAllowedDomainLabel = () => {
  if (!APP_CONFIG.allowedEmailDomain) {
    return 'Any Google account can be used until you add your own restriction.';
  }

  return `Only ${APP_CONFIG.allowedEmailDomain} accounts are allowed.`;
};
